import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import Loader from './../../shared/loader'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'

export default {
	name: 'warehouseStockReport',
	components: {
		Paginate,
		Pagination,
		DatePicker,
		download,
		JsonExcel,
		Loader,
		BasicSelect
	},
	props: [],
	data() {
		return {
			// totalRows: 0,
			// currentPage: 0,
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			ProductID: '',
			rackid: '',
			formattedDate: '',
			resultCount: '',
			ClientErr: '',
			WarehouseErr: '',
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			fromdate: '',
			todate: '',
			invreferenceid: '',
			pono: '',
			brand: '',
			user_type: '',
			// perPage: 10,
			// pageno: 0,
			// totalPage: 0,
			isLoading: false,
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			listWhrStockReportDataCsv: [],
			listWhrStockReportData: [],
			csvFields: [],
			listClientData: [],
			listWarehouseData: [],
			listMerchantData: [],
			listsubinventoryData: [],
			subinventory: '',
			userid: '',
			merchantname: '',
			stocktype: '',
			stocktypeErr: '',
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			recordLimit: 0,
			limitExeed: false,
			item: {},
			merchant: '',
			listMerchantData1: [],
			merchantList: [],
			merchantname: '',
			activemrpflag:false,
			isInventoryZone:false,
			zonename:''
		}
	},
	computed: {

	},
	filters: {
		moment: function (date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD');
		}
	},
	mounted() {
		this.warehouseid = '';
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		this.userid = userdetail.userid;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('editedjson.WarehouseStockReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		//this.getWhrStockReportData();
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantList();
		this.getsubinventoryList();
		}
		if(this.clientid!=='undefined' && this.warehouseid!=='undefined'){
			this.getInventoryZonePermission();
		}
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.showSelectWarehouse = true;
				this.client = this.clientid;
				this.showSelectMerchant = true;
				// this.getWarehouseList();
				this.getMerchantList();
				this.getsubinventoryList();
				this.getActiveMrpFlag();
				if (userdetail.merchantid) {
					this.mid = userdetail.merchantid.toString()
					this.merchantname = this.mid
					this.showSelectMerchant = false;
				}
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit()
		this.$root.$on('localStorageChanged', (newValue) => {
			// Update your local data
			this.warehouse = newValue;
			if(window.localStorage.getItem('selectedWarehouse')!=='undefined'){
			  this.getInventoryZonePermission();
			}
		  });
	},
	methods: {
		reset() {
			this.item = {}
		},
		onSelect(item) {

			this.item = item
			this.merchantname = item.value
		},
		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;
					}
				}, error => {
					console.error(error)
				})
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getWhrStockReportDataForXls(3)
			}
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;

		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },

		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {

		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				// console.log(result.data.data);
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 		this.clientid = this.client;
		// 		this.merchantname = '';
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getsubinventoryList();
		// 			this.getMerchantList();
		// 			this.getActiveMrpFlag();

		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getMerchantList();
		// 				this.getActiveMrpFlag();
		// 				this.item = {}
		// 				this.getsubinventoryList();
		// 				// this.getWhrStockReportData();
		// 			}
		// 		}
		// 	}
		// 	this.listWhrStockReportData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			// this.getWhrStockReportData();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getMerchantList() {
			this.listMerchantData1 = []
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data && result.data.length > 0) {
						this.listMerchantData = result.data;
						var merchantlistArray = [];
						this.item = {
							value: '',
							text: ''
						};
						this.listMerchantData1 = [{
							value: '',
							text: this.$t('common.selectMerchantPlaceHolder')
						}];
						result.data.forEach(function (item) {
							merchantlistArray[item.merchantid] = item.merchantname;

						})
						this.merchantList = merchantlistArray;
						this.listMerchantData.forEach(ele => {
							this.listMerchantData1.push({
								"value": ele.merchantid,
								"text": ele.merchantname
							})
						})

					}

				}, error => {
					console.error(error)
				})
		},
		async getActiveMrpFlag(){
 				 var userToken = window.localStorage.getItem('userToken');
 				 var myStr = userToken.replace(/"/g, '');
 				 this.input = ({
 					 "clientid": localStorage.getItem('selectedClient'),
 				 });
 			 try {

 					 axios({
 							 method: 'POST',
 							 'url': apiUrl.api_url + 'checkActivemrpFlg',
 							 'data': this.input,
 							 headers: {
 								 'Authorization': 'Bearer ' + myStr,
 							 }
 						 })
 						 .then(result => {
 							 if(result.data.data.data[0].value ==='yes'){
 								 this.activemrpflag = true;
 							 }else{
 								 this.activemrpflag = false;
 							 }
 						 }, error => {
 							 console.error(error);
 						 });

 				 } catch (err) {
 					 throw new Error(err);
 				 }
 	 },
	  async getInventoryZonePermission(){
		var userToken = window.localStorage.getItem('userToken')
		var myStr = userToken.replace(/"/g, '');
		this.input=({
			clientid:window.localStorage.getItem("selectedClient"),
			warehouseid:window.localStorage.getItem("selectedWarehouse"),
		})
		const result=await axios({
			method:'POST',
			'url':apiUrl.api_url+'getInventoryZonePermission',
			'data':this.input,
			headers:{
				'Authorization':'Bearer '+myStr
			}
		})
		try{
		   this.isInventoryZone=result.data.inventoryZoneStatus
		}catch(error){
			console.error(error)
		}
	},
		getsubinventoryList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: localStorage.getItem('selectedClient'),
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSubInventoryList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					console.log(result, "res---->")
					if (result.data && result.data.length > 0) {
						this.listsubinventoryData = result.data;

					}
				}, error => {
					console.error(error)
				})
		},
		//to get warehouse stock list
		getWhrStockReportData(csvCheck = 0) {
			if (csvCheck == 2) {
				this.limitExeed = false
			}
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
			}
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))
				this.pageNo = this.totalPage = 0;
				this.listWhrStockReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listWhrStockReportData = [];
				return false;
			}
			if (this.stocktype == '') {
				this.stocktypeErr = this.$t('common.stockTypeRequired');
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1);
			}

			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem('selectedWarehouse'),
				userid: this.userid,
				merchantid: this.merchantname,
				rackid: this.rackid,
				brand: this.brand,
				productid: this.ProductID,
				eancode: this.eancode,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				subinventory: this.subinventory,
				stocktype: this.stocktype,
				csvData: csvCheck,
				zonename:this.zonename,
				isInventoryZone:this.isInventoryZone
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData','isInventoryZone'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			this.isLoading = true;

			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehouseStockReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							this.show = true;
							this.download = false;
							this.listWhrStockReportDataCsv = [];
							this.csvFields = {
								'productid': this.$t('common.productId'),
                                'eancode': this.$t('inwardList.printData.productDetails.eanCode'),
                                'productname': this.$t('printProductDetails.productName'),
                                'brand': this.$t('common.brandName'),
                                'productcategory': this.$t('productPlaceHolder.productCategory'),
                                'mrp': this.$t('removeHold.productMrp'),
																'activemrp': this.$t('common.activemrp'),
                                'rackid': this.$t('warehouseRacks.rackId'),
                                'racktype':  this.$t('pickPendingMoveOrder.table.columns.rackType'),
                                'whrackstock': this.$t('reports.rackStock'),
                                'whcurrentstock': this.$t('daywiseatpstock.currentstock'),
                                'merchantname': this.$t('packingReportList.table.columns.merchantName'),
                                'subinventory': this.$t('warehouseRacks.subinventory'),
                                'lotno': this.$t('grcList.lotNo'),
                                'expirydate': this.$t('printProductDetails.expiryDate'),
                                'rackcapacity': this.$t('warehouseRacks.rackCapacity'),
								'zonename':this.$t('common.zoneName')
							};
							var dateFilter = [];
							if(this.activemrpflag === true){
								var skipFilter = ['rowcount'];
							}else {
								var skipFilter = ['rowcount','activemrp'];
							}

							if(this.isInventoryZone===false){
								skipFilter.push('zonename')
							}
							this.listWhrStockReportDataCsv = result.data.data;
							csvHelper.data.jsonToCSV(this.$t('editedjson.WarehouseStockReport')
							, this.listWhrStockReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

							// this.jsonToCSV('WarehouseStockReport', this.listWhrStockReportDataCsv, this.csvFields, dateFilter, skipFilter);
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listWhrStockReportData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0;
							this.totalRows = 0;
						} else {
							this.totalRows = result.data.count;
							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							this.resultCount = result.data.count;
							if (this.totalRows <= this.pageLimit) {
								this.totalPage = 1;
							} else {
								this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
							}
						}
					}

					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getWhrStockReportDataForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';
			// this.ClientErr = '';
			if (localStorage.getItem("selectedClient") == '') {
				this.ClientErr = this.$t('srReport.clientError');
				this.pageNo = this.totalPage = 0;
				this.listWhrStockReportData = [];
				return false;
			}
			if (localStorage.getItem("selectedWarehouse") == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.totalPage = 0;
				this.listWhrStockReportData = [];
				return false;
			}
			if (this.stocktype == '') {
				this.stocktypeErr = this.$t('brandwisestock.stockTypeValError');
				this.pageNo = this.totalPage = 0;
				this.listStockReportData = [];
				return false;
			}

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1);
			}

			this.input = ({
				clientid: localStorage.getItem("selectedClient"),
				warehouseid: localStorage.getItem("selectedWarehouse"),
				userid: this.userid,
				merchantid: this.merchantname,
				rackid: this.rackid,
				brand: this.brand,
				productid: this.ProductID,
				eancode: this.eancode,
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				subinventory: this.subinventory,
				stocktype: this.stocktype,
				csvData: csvCheck,
				zonename:this.zonename,
				isInventoryZone:this.isInventoryZone
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData','isInventoryZone'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})


			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getWarehouseStockReport',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {
							this.listReportDataforxls = [];
							this.csvFieldsForXls =[];
                                this.csvFieldsForXls[this.$t('common.productId')] =  'productid';
                                this.csvFieldsForXls[this.$t('inwardList.printData.productDetails.eanCode')] = 'eancode';
                                this.csvFieldsForXls[this.$t('printProductDetails.productName')] = 'productname';
                                this.csvFieldsForXls[this.$t('common.brandName')] = 'brand';
                                this.csvFieldsForXls[this.$t('productPlaceHolder.productCategory')] =  'productcategory';
                                this.csvFieldsForXls[this.$t('removeHold.productMrp')] =  'mrp';
																if(this.activemrpflag === true){
																	this.csvFieldsForXls[this.$t('common.activemrp')] =  'activemrp';
																}
                                this.csvFieldsForXls[this.$t('warehouseRacks.rackId')] = 'rackid';
                                this.csvFieldsForXls[this.$t('pickPendingMoveOrder.table.columns.rackType')] = 'racktype';
                                this.csvFieldsForXls[this.$t('reports.rackStock')] = 'whrackstock';
                                this.csvFieldsForXls[this.$t('daywiseatpstock.currentstock')] = 'whcurrentstock';
                                this.csvFieldsForXls[this.$t('packingReportList.table.columns.merchantName')] = 'merchantname';
                                this.csvFieldsForXls[this.$t('warehouseRacks.subinventory')] =  'subinventory';
                                this.csvFieldsForXls[this.$t('grcList.lotNo')] = 'lotno';
                                this.csvFieldsForXls[this.$t('printProductDetails.expiryDate')] =  'expirydate';
                                this.csvFieldsForXls[this.$t('warehouseRacks.rackCapacity')] =  'rackcapacity';
								if(this.isInventoryZone ===true){
									this.csvFieldsForXls[this.$t('common.zoneName')]='zonename';
								}

							this.listReportDataforxls = result.data.data;
						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}

				}, error => {
					console.error(error);
				})
		},
		//for filter warehouse stock as per entered requirement
		getWhrStockReportSearch() {
			this.currentPage = 1;
			this.totalPage = 0;
			this.searchFlag = true;
			this.getWhrStockReportData(2);
		},

		//to get pagination
		// getPaginationData(currentPage) {
		//   this.pageno = (currentPage - 1) * this.perPage;
		//   this.getWhrStockReportData();
		// },
		onPageChange(page) {
			this.currentPage = page;
			this.getWhrStockReportData()
		},
		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.show = false;
			this.download = true;
			this.ProductID = '';
			this.orderid = '';
			this.rackid = '';
			this.merchantname = '',
				this.subinventory = '',
				this.brand = '';
			this.pageno = 0;
			this.totalRows = 0;
			this.stocktype = '';
			this.searchFlag = false;
			this.listWhrStockReportData = [];
			this.item = {}
			this.zonename=''
			// if (this.user_type == 'warehouse_user')
			// 	this.client = '';
			// else if (this.user_type == 'client_user')
			// 	this.warehouse = '';
			// else {
			// 	this.client = '';
			// 	this.warehouse = '';
			// }
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/warehouseStockReport/warehouseStockReport.component.js